import styled from '@emotion/styled'

type KnobProps = {
  stripeWidthPercentage: number
}

export default styled.div((props: KnobProps) => ({
  label: 'Knob',
  position: 'absolute',
  background:
    'radial-gradient(circle at 65% 35%, rgb(255 255 255 / 49%), rgb(255 255 255 / 20%) 40%, rgb(255 255 255 / 20%) 40%)',
  opacity: 1,
  borderRadius: '50%',
  width: `${props.stripeWidthPercentage - props.stripeWidthPercentage / 7}%`,
  height: `${props.stripeWidthPercentage - props.stripeWidthPercentage / 7}%`,
  border: '2px solid transparent',
  top: `${props.stripeWidthPercentage / 25}%`,
  right: '39.5%',
}))
